import AndroidIcon from "@mui/icons-material/Android";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import { APP_PLATFORM } from "../../../utils/appPlatform";

const CARDS = [
  { platform: APP_PLATFORM.ANDROID, label: "Android", icon: AndroidIcon, color: "#1e7e34" },
  { platform: APP_PLATFORM.IOS, label: "iOS", icon: PhoneIphoneIcon, color: "#104581" },
];

const AppVersionsSummary = ({ latestVersions }) => (
  <div className="app-versions-summary">
    {CARDS.map(({ platform, label, icon: Icon, color }) => {
      const latest = latestVersions?.[platform];
      return (
        <div key={platform} className="app-versions-summary_card">
          <span className="app-versions-summary_card_icon" style={{ color }}>
            <Icon fontSize="large" />
          </span>
          <div className="app-versions-summary_card_body">
            <span className="app-versions-summary_card_label">Latest {label} Version</span>
            <span className="app-versions-summary_card_version">
              {latest?.version || "No version published yet"}
            </span>
            {latest?.releaseNotes && (
              <span className="app-versions-summary_card_notes">{latest.releaseNotes}</span>
            )}
          </div>
        </div>
      );
    })}
  </div>
);

export default AppVersionsSummary;
